import ContentLoader from 'react-content-loader'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {SpacialFn, styled} from '@yosmanyga/web-style'
import {LinePlaceholderProps} from '@yosmanyga/primitive-ui-spec'

export const LinePlaceholder = ({
    uniq,
    width, height, color, background
}: LinePlaceholderProps & UnnormalizedStyleProps) => {
    width = ((SpacialFn.normalizeWidth(width))?.def || 12) as number;
    height = ((SpacialFn.normalizeHeight(height))?.def || 12) as number;

    return <ContentLoader
        uniqueKey={uniq}
        width={width}
        height={height}
        foregroundColor={color}
        backgroundColor={background as string}
    >
        <rect x="0" y="0" rx="0" ry="0" width={width} height={height}/>
    </ContentLoader>
}

const StyledLinePlaceholder = styled(LinePlaceholder)`
    ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
`

export default StyledLinePlaceholder
